import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobFullDetailsJobNotificationsDetails from './job-full-details-job-notifications-details.jsx';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsJobNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      job_notifications_data: props.job_notifications_data || null,
      isLoadingNotificationsInfo: true,
      data: props.data || null
    }
  }

  componentDidMount() {
    this.getNotifications();
    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).
    listen(
      'NewNotification',
      (e) => {
        this.getNotifications();
      }
    );
  }

  getNotifications() {
    let url = '/api/v1/portal/jobs/notifications/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((jobNotificationsJson) => {
        this.setState({
          job_notifications_data: jobNotificationsJson,
          isLoadingNotificationsInfo: false,
        })
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  
  render() {
    let JobNotifications = [];
    if (this.state.job_notifications_data &&
      this.state.job_notifications_data.length > 0) {
      let jobId = this.state.data.id;
      this.state.job_notifications_data.forEach(function(i) {
        JobNotifications.push(
          <div key={"job-"+jobId+"-notification-"+i.id}>
            <div className="profile-container">
              <span className="small sidebar-time">{i.sidebar_time}</span>
              <img src={"/user-images/"+i.user_id} width="50" height="50" />
              <span>
                <a href={"/portal-admin/users/view/"+i.user_id}>
                  {i.user_name}
                </a> from <a href={"/portal-admin/companies/"+
              i.user_company_short_name}>
                  {i.user_company_short_name}
                </a>
              </span>
              { (i.history && i.history.length > 0) ? <JobFullDetailsJobNotificationsDetails data={i.history}/> : '' }
            </div>
            <div dangerouslySetInnerHTML={{__html: i.message}}
                 className="text-right"></div>
            <hr />
          </div>
        );
      });
    }
    return (
      <div className="jobs-table-job-notifications-container">
        {JobNotifications}
      </div>
    )
  }
}